export default __webpack_public_path__ + "static/media/NoDataImage.04dada1c.svg";